import {
	createAsyncThunk,
	createSlice,
	PayloadAction,
	Action,
	createAction,
	AnyAction
} from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../app/store';

import { Nr } from '../../util/types';
import { fetchNotes } from './noteAPI';



// Interfaces for conceptual objects
//
//
//



export interface Note {
	id?: string;
	oldId?: string;
	created: string;
	modified?: string;
	archived?: string;
	deleted?: string;
	user?: Nr;
	modifiedUser?: Nr;
	deletedUser?: Nr;
	admin?:  Nr;
	organisation?: Nr;
	title: string;
	content: string;
}

function noteDefaultOne(): Note {
	return {
		created: '2022-11-18 04:00:00Z',
		title: 'my title for one',
		content: '## this is some\n **bold** content in `markdown`',
	};
}

/*
 * use declare when https://google.github.io/styleguide/tsguide.html#optimization-compatibility-for-property-access

ˇˇˇˇ 
// Good: using "declare" to declare types that are external to the application,
// so that their properties are not renamed.
declare interface ServerInfoJson {
  appVersion: string;
  user: UserJson; // Note: UserJson must also use `declare`!
}
// serverResponse must be ServerInfoJson as per the application's contract.
const data = JSON.parse(serverResponse) as ServerInfoJson;
console.log(data.appVersion); // Type safe & renaming safe!

ˆˆˆˆ

// */



// Interfaces for actions, queries
//
// https://redux-toolkit.js.org/api/createSlice#the-extrareducers-builder-callback-notation

/*
export interface AddNotesAction extends Action {
	notes: {[key: string]: Note},
}
function isAddNotesAction(action: AnyAction): action is AddNotesAction {
	return action.type.endsWith('addNotes');
}
// */

interface setSelectedPayload {
	container: string;
	id: string;
	value: boolean;
}

interface fetchNoteResult {
	errors: [string];
	data: {[key: string]: Note};
}



// State !
//
//
//



export interface NoteState {
  selected: {[key:string]:{[key:string]: boolean}};
  notes: {[key:string]: Note};
  drafts: Note[];
}

const initialState: NoteState = {
  selected: {
	  'main': {},
  },
  notes: {},
  drafts: [],
};

const testInitialState: NoteState = {
	selected: {
		'main': {
			'1': true,
		}
	},
	notes: {
		'1': { id: '1', created: '2022-11-18 04:00:00Z',
			title: 'title 1', content: 'content 1'},
		'2': { id: '2', created: '2022-11-18 04:00:00Z',
			title: 'title 2', content: 'content 2'},
		'3': { id: '3', created: '2022-11-18 04:00:00Z',
			title: 'title 3', content: 'content 3'},
	},
	drafts: [
		{
			created: '2022-11-18 04:00:00Z',
			title: 'my title for one',
			content: '## this is some\n **bold** content in `markdown`',
		}
	],
}

// Actions
//
//

export interface AddNotesPayload {
  notes: {[key:string]: Note};
  drafts: Note[];
}


export const addNotes = createAction(
	'notes/addNotes',
	function prepare(notes: AddNotesPayload) {
	return {
		payload: notes
	}
})

function addNotesReducer(state: NoteState, action: PayloadAction<AddNotesPayload>): NoteState {
	console.log('addNotesReducer', state, action);
	//return state;
	const notes = {...state.notes, ...action.payload.notes};
	state.notes = notes;
	return state;
}

// Thunks !
//
//
//



// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const incrementAsync = createAsyncThunk(
  'note/fetchNotes',
  async (amount: number) => {
    const response = await fetchNotes(amount);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const fetchNoteByIdAsync = createAsyncThunk(
  'note/fetchNoteById',
  async (amount: number) => {
    const response = await fetchNotes(amount);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);



// Reducers !
//
//
//



export const noteSlice = createSlice({
  name: 'note',
  initialState,
  //testInitialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    select: (state, action:PayloadAction<setSelectedPayload>) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.selected[action.payload.container][action.payload.id] = action.payload.value;
    },
	/*
	//addNotes: (state, action:PayloadAction<{[key:string]: Note}>) => {
	addNotes: (state, action:PayloadAction<AddNotesAction>) => {
		state.notes = {...state.notes, ...action.payload};
	 // console.log('action payload:');
	  //console.log(action.payload);
	},
    // */
    decrement: (state) => {
      state.selected['main'][''] = true;
    },
    // Use the PayloadAction type to declare the contents of `action.payload`
    incrementByAmount: (state, action: PayloadAction<number>) => {
      state.selected['main'][''] = true;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
	  builder
	  .addCase(incrementAsync.pending, (state) => {
		  state.selected['main'][''] = true;
	  })
	  .addCase(incrementAsync.fulfilled, (state, action) => {
		  state.selected['main'][''] = true;
	  })
	  .addCase(incrementAsync.rejected, (state) => {
		  state.selected['main'][''] = true;
	  })
	  .addCase(addNotes, (state, action: PayloadAction<AddNotesPayload>) => {
		  addNotesReducer(state, action);
		  state.selected['main'][''] = true;
	  });
  },
});

export const { select, /*addNotes,*/ decrement, incrementByAmount } = noteSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.note.value)`
export const selectCount = (state: RootState) => state.note.selected['main'][''];

export const selectNotes =  (state: RootState) => state.note.notes;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const incrementIfOdd =
  (amount: number): AppThunk =>
  (dispatch, getState) => {
    const currentValue = selectCount(getState());
    if (currentValue) {
      dispatch(incrementByAmount(amount));
    }
  };

export default noteSlice.reducer;


// Test Data
export const testNoteA: Note = {
	id: '6e37352e-be4f-4fd0-928c-ded59590909d',
	created: '2022-11-18 05:00:00Z',
	title: 'title A',
	content: 'this is content',
};
export const testNoteB: Note = {
	id: 'b',
	created: '2022-11-18 05:00:00Z',
	title: 'title B',
	content: 'this is content',
};
export const testNoteC: Note = {
	id: 'c',
	created: '2022-11-18 05:00:00Z',
	title: 'title C',
	content: 'this is content',
};
export const testNoteD: Note = {
	id: 'd',
	created: '2022-11-18 05:00:00Z',
	title: 'title D',
	content: 'this is content',
};

export const testAddNotesPayload = {
	notes:{
		'6e37352e-be4f-4fd0-928c-ded59590909d': testNoteA,
		'dd938832-28f6-41f0-a4c2-2e4bb3dada12': testNoteB,
		'053f367a-f0bf-494f-b02d-e6939d215a24': testNoteC,
		'02f1d021-b1db-4b5a-b32a-744c82a1c62e': testNoteD,
	},
	drafts:[],
}

